var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderForm',{attrs:{"supplier-from-voice":_vm.supplierFromVoice,"fromSubStock":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }